import { Link } from "react-router-dom";
import logo from "@/images/logo_with_bg-removebg-preview.png";

export default function Logo({
  className = "h-10 md:h-12",
  link = true,
  testId = "site-logo",
}) {
  const image = (
    <img
      src={logo}
      alt="Petal Pookie"
      className={`${className} w-auto object-contain`}
      style={{
        width: "110px",
        height: "120px",
      }}
    />
  );

  if (!link) {
    return image;
  }

  return (
    <Link to="/" className="inline-flex items-center shrink-0" data-testid={testId}>
      {image}
    </Link>
  );
}
